import { useId } from 'react'

import { AstraParagraph } from '../../Typography/AstraParagraph/AstraParagraph'

type Props = {
    errorText?: string
    error?: boolean
}

export const AstraErrorText = ({ errorText, error }: Props) => {
    const uniqueId = useId()
    const errorTextId = `error-text-${uniqueId}`

    if (!error || !errorText) return null

    return (
        <AstraParagraph id={errorTextId} aria-live="polite" variant="body-small" className="text-wrap text-critical">
            {errorText}
        </AstraParagraph>
    )
}
